import Vue from 'vue'
import Vuex from 'vuex'

//使用vuex
Vue.use(Vuex)

//导出store
export default new Vuex.Store({
    state: {

        currentFolderId: '',            // 当前上传的压缩包id
        uploadProgressPercent: 0,       // 上传文件进度条
        validStatus: 0,                 // 校验状态
        isUploadProgress: false,        // 是否显示上传文件进度条
        isFileChecked: true,            // 校验控制：false校验中、true校验错误
        isFileUploadSuccess: false,     // 是否显示上传文件成功
        toDiagnose: false,              // 是否需要诊断
        uploadFileName: '',             // 当前上传文件名称
        isDiagnoseProgress: false,      // 是否显示诊断进度条
        currentProject: null,           // 当前项目
        currentFileList: [],          // 当前上传的压缩包解压后，文件idlist
        toValidFileIdList: [],                // 上传文件中途刷新，数据丢失，每5s请求一次看是否有已上传未校验的文件，有则放在这里，去请求校验后清空
        validatedList: [],              // 诊断接口返回的结果，已经诊断过的文件
        toDiagnoseList: [],             // 校验文件中途刷新，数据丢失，每5s请求一次看是否有已校验未诊断的文件，有则放在这里，去请求诊断后清空


    },
    mutations: {


        setToValidFileIdList(state, value) {
            state.toValidFileIdList = value
        },
        setValidatedList(state, value) {
            state.validatedList = value
        },
        setCurrentFolderId(state, value) {
            state.currentFolderId = value
        },
        setCurrentProject(state, value) {
            state.currentProject = value
        },
        setValidStatus(state, value) {
            state.validStatus = value
        },
        setUploadProgressPercent(state, value) {
            state.uploadProgressPercent = value
        },
        setIsDiagnoseProgress(state, value) {
            state.isDiagnoseProgress = value
        },
        setUploadFileName(state, value) {
            state.uploadFileName = value
        },
        setToDiagnose(state, value) {
            state.toDiagnose = value
        },
        setIsFileUploadSuccess(state, value) {
            state.isFileUploadSuccess = value
        },
        setIsFileChecked(state, value) {
            state.isFileChecked = value
        },
        setIsUploadProgress(state, value) {
            state.isUploadProgress = value
        },
        setCurrentFileList(state, value) {
            state.currentFileList = value
        },
    },


})